import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { AdvanceInvoiceConceptModel } from 'src/app/models/invoicing/advance-invoice-concept.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdvanceInvoiceConceptService {

  private readonly _httpClient = inject(HttpClient);

  getAdvanceInvoiceConceptById(advanceInvoiceConceptId: number): Observable<AdvanceInvoiceConceptModel> {
    return this._httpClient.get<AdvanceInvoiceConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoiceConcept.GetByIdAsync}/${advanceInvoiceConceptId}`);
  }

  getAdvanceInvoiceConceptsByAdvanceInvoiceIdWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, invoiceId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '')
      .set('ascendant', ascendant).set('invoiceId', invoiceId);

    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoiceConcept.GetAdvanceInvoiceConceptsByAdvanceInvoiceIdWithPagination}`,
      { params }
    );
  }

  getColumnsForConceptsAdvanceInvoice(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoiceConcept.GetColumnsForConceptsAdvanceInvoiceAsync}`);
  }

  updateAdvanceInvoiceConcept(advanceInvoiceConceptContract: AdvanceInvoiceConceptModel): Observable<AdvanceInvoiceConceptModel> {
    return this._httpClient.put<AdvanceInvoiceConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoiceConcept.UpdateAsync}`,
      advanceInvoiceConceptContract);
  }

}
